// CtaBanner.jsx — Vertex-blue CTA (pulse + shine + ripple + spacing)
import React, { useRef } from "react";

const BRAND = "#0b66c3"; // Vertex Suite blue

export default function CtaBanner() {
  const demoBtnRef = useRef(null);
  const salesBtnRef = useRef(null);

  const setRipple = (ref, e) => {
    const el = ref.current;
    if (!el) return;
    const r = el.getBoundingClientRect();
    el.style.setProperty("--rx", `${e.clientX - r.left}px`);
    el.style.setProperty("--ry", `${e.clientY - r.top}px`);
  };

  return (
    <section className="cta-wrap">
      <style>{`
        :root{ --brand:${BRAND}; --ink:#0f172a; --muted:#64748b; --border:#e6edf5; }
        .cta-wrap, .cta-wrap *{ box-sizing:border-box; font-family:Inter, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial; }

        /* Section gap */
        .cta-wrap { padding: 80px 0; background:#fff; }

        .container{ max-width:1100px; margin:0 auto; padding:0 20px; }

        .cta{ text-align:center; }
        .cta h2{ margin:0 0 20px; font-size:44px; line-height:1.12; font-weight:900; color:var(--ink); letter-spacing:.2px; }
        .cta p{ margin:0 0 32px; color:var(--muted); font-size:18px; }

        .cta-actions{ position:relative; display:flex; justify-content:center; gap:16px; flex-wrap:wrap; margin-bottom:20px; }

        .btn{
          position:relative; display:inline-flex; align-items:center; justify-content:center;
          padding:14px 22px; border-radius:12px; font-weight:900; letter-spacing:.2px; cursor:pointer; outline:none; overflow:hidden;
          transition: transform .12s ease, box-shadow .2s ease, filter .2s ease, background .2s ease, color .2s ease, border-color .2s ease;
        }
        .btn-primary{
          color:#fff; border:none; background: var(--brand);
          box-shadow: 0 18px 40px rgba(11,102,195,.28);
          animation: pulse 2.8s ease-in-out infinite;
        }
        .btn-primary:hover{ transform: translateY(-1px); filter: brightness(1.02); }
        .btn-primary:active{ transform: translateY(0); }

        .btn-primary::after{
          content:""; position:absolute; inset:0;
          background: linear-gradient(120deg, transparent 35%, rgba(255,255,255,.75) 50%, transparent 65%);
          transform: translateX(-160%); transition: transform .8s ease; pointer-events:none;
        }
        .btn-primary:hover::after{ transform: translateX(160%); }

        .btn-outline{ color:#0f172a; background:#fff; border:1.6px solid var(--border); }
        .btn-outline:hover{ transform: translateY(-1px); border-color:#d9e7ff; color:var(--brand); background:#fbfdff; box-shadow:0 12px 24px rgba(2,6,23,.06); }

        .btn-ripple{
          position:absolute; inset:0; pointer-events:none; opacity:0; transform:scale(.9);
          background: radial-gradient(220px circle at var(--rx,50%) var(--ry,50%), rgba(255,255,255,.5), transparent 60%);
          transition: opacity .45s ease, transform .45s ease;
        }
        .btn:active .btn-ripple{ opacity:1; transform:scale(1); }

        .cta-glow{
          position:absolute; left:50%; transform:translateX(-50%); width:260px; height:70px; margin-top:40px; border-radius:50%;
          background:
            radial-gradient(60% 90% at 50% 25%, rgba(11,102,195,.30), transparent 70%),
            radial-gradient(60% 90% at 50% 75%, rgba(34,197,94,.22), transparent 70%);
          filter: blur(14px); pointer-events:none;
        }
        @keyframes pulse{
          0%,100%{ box-shadow: 0 18px 40px rgba(11,102,195,.28); }
          50%    { box-shadow: 0 22px 52px rgba(11,102,195,.38); }
        }
        @media (max-width:640px){
          .cta h2{ font-size:34px; }
        }
      `}</style>

      <div className="container">
        <div className="cta">
          <h2>Ready to turn ads into conversations?</h2>
          <p>Launch, automate, and scale your WhatsApp acquisition.</p>

          <div className="cta-actions">
            <button
              ref={demoBtnRef}
              className="btn btn-primary"
              onMouseDown={(e) => setRipple(demoBtnRef, e)}
              type="button"
            >
              Book a Demo
              <span className="btn-ripple" aria-hidden="true" />
            </button>

            <button
              ref={salesBtnRef}
              className="btn btn-outline"
              onMouseDown={(e) => setRipple(salesBtnRef, e)}
              type="button"
            >
              Talk to Sales
              <span className="btn-ripple" aria-hidden="true" />
            </button>

            <div className="cta-glow" aria-hidden="true" />
          </div>
        </div>
      </div>
    </section>
  );
}
